<body >
  <app-nav-menu></app-nav-menu>
  <div class="rootcontainer">
    <router-outlet></router-outlet>
  </div>
</body>
